import React, { useEffect, useState } from "react";
import { without } from "lodash";

import Select from 'react-select';
import MessageOptionsSelect from './MessageOptionsSelect';
import InteractiveList from './InteractiveList';
import AddOptionButton from './AddOptionButton';
import selectStyles from '../../../util/selectStyles';
import { getOptionCollection } from './utils';
import IconMC from '../../../presentation/components/IconMC';

const OptionsSublist = ({
  chatbotOption,
  setChatbotOption,
  errors,
  maxCharacters,
  apiVariables = [],
  chatbot
}) => {
  const optionSubLists = getOptionCollection(chatbotOption, 'option_sub_lists');
  const enabledOptionsList = optionSubLists.filter((el) => el._destroy !== true);
  const hasVariables = apiVariables.length > 0;
  const [variablesOptions, setVariablesOptions] = useState([]);
  const [subVariablesOptions, setSubVariablesOptions] = useState([]);

  const updateInfo = (name, value) => {
    setChatbotOption((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const addNewOption = () => {
    const newArray = optionSubLists.concat({
      id: null,
      value_to_show: '',
      list_item_description: '',
      _destroy: false
    });

    updateInfo('option_sub_lists', newArray);
  };

  const handleInputOptChange = (option) => (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    const newArray = [...optionSubLists];
    const index = newArray.lastIndexOf(option);

    if (index !== -1) newArray[index][name] = value;

    updateInfo('option_sub_lists', newArray);
  };

  const removeOption = (opt) => {
    let newArray = [...optionSubLists];

    if (!opt.id) {
      newArray = without(optionSubLists, opt);
    } else {
      const optIndex = optionSubLists.lastIndexOf(opt);
      newArray[optIndex]._destroy = true;
    }

    updateInfo('option_sub_lists', newArray);
  };

  const handleUseApiVariables = () => {
    const newValue = !chatbotOption.use_api;
    const newValues = {
      ...chatbotOption,
      use_api: newValue
    };

    if (!newValue) {
      newValues.form_options = {
        ...(chatbotOption.form_options || {}),
        data_source: '',
        value_source: '',
        title_source: ''
      };
    }
    setChatbotOption(newValues);
  };

  const handleVariablesSelect = (option, field) => {
    const formOptions = {
      ...(chatbotOption.form_options || {}),
      [field.name]: option.value
    };
    if (field.name === 'data_source') {
      formOptions.value_source = '';
      formOptions.title_source = '';
    }
    setChatbotOption({
      ...chatbotOption,
      form_options: formOptions
    });
  };

  useEffect(() => {
    if (chatbotOption.use_api) {
      const options = apiVariables.map((item) => ({
        value: item,
        label: item
      }));

      setVariablesOptions(options);
    }
  }, [chatbotOption.use_api, apiVariables]);

  useEffect(() => {
    if (chatbotOption?.form_options?.data_source) {
      setSubVariablesOptions(
        variablesOptions.filter((item) => item.value.startsWith(`${chatbotOption.form_options.data_source}.`))
      );
    }
  }, [chatbotOption?.form_options?.data_source, variablesOptions]);

  return chatbotOption.answer_type === 'unique' && (
  <>
    <div className="col-md-12 mt-20">
      <MessageOptionsSelect
        chatbotOption={chatbotOption}
        updateInfo={updateInfo}
        errors={errors}
        chatbot={chatbot}
      />
    </div>

    {chatbotOption.interactive === 'list' && (
      <InteractiveList
        chatbotOption={chatbotOption}
        updateInfo={updateInfo}
        errors={errors}
      />
    )}

    {hasVariables && (
      <div className="col-md-12 mt-20">
        <div className="d-flex">
          <label className="switch">
            <input
              type="checkbox"
              name="skip_option"
              checked={chatbotOption.use_api}
              onChange={handleUseApiVariables}
            />
            <span className="slider round" />
          </label>
          <span className="fz-14 text-gray-dark ff-semi-bold">
            Utilizar respuesta API
          </span>
        </div>
        {chatbotOption.use_api && (
        <>
          <span className="fs-12 text-gray-light">
            Al activar esta opción puedes utilizar la respuesta del API.
          </span>
          {chatbotOption.interactive !== 'text' && (
            <div className="cold-status p-16 border-12 d-flex align-items-center fs-12 mt-8">
              <IconMC name="checkmark-circle-2-outline" size="base" className="tw-mr-1 tw-flex-shrink-0" />
              Se mostrarán las primeras
              {' '}
              {chatbotOption.interactive === 'buttons' ? 3 : 10}
              {' '}
              opciones de la respuesta del API.
            </div>
          )}
          <div className="warm-status p-16 border-12 d-flex align-items-center fs-12 mt-8">
            <IconMC name="checkmark-circle-2-outline" size="base" className="tw-mr-1 tw-flex-shrink-0" />
            Si la respuesta del API llega vacía se omitirá este paso en el flujo.
          </div>
        </>
        )}
      </div>
    )}

    <div className="col-md-12 mt-20">
      <label className="col-form-label fz-14 mr-10">¿Qué opciones tendrá el usuario para escoger?</label>
    </div>

    {errors.options_sublist_error && (
    <div className="col-md-12 mt-10">
      <span className="ml-10 error-msg fz-12">{errors.options_sublist_error}</span>
    </div>
    )}

    {!chatbotOption.use_api ? enabledOptionsList.map((opt, index) => (
      <div className="col-md-12 mt-20 d-flex justify-content-between" key={`opt-for-list-${index}`}>
        <div className="col-md-1 d-flex align-items-center">
          <span className="font-500">{index + 1}</span>
        </div>
        <div className="px-0 col-md-10">
          <div className="figma-field mb-0">
            <label>Opción</label>
            <span className="ml-10 error-msg fz-12">{opt.error}</span>
            <input
              value={opt.value_to_show}
              onChange={handleInputOptChange(opt)}
              className="input"
              name="value_to_show"
              maxLength={maxCharacters()}
            />
          </div>
          {chatbotOption.interactive === 'list' && (
            <div className="figma-field mb-0 mt-10">
              <label>Descripción (opcional)</label>
              <input
                value={opt.list_item_description || ''}
                onChange={handleInputOptChange(opt)}
                className="input"
                name="list_item_description"
                maxLength={72}
                placeholder="Texto adicional bajo el título en WhatsApp"
              />
            </div>
          )}
        </div>

        <button
          type="button"
          className="tw-flex tw-cursor-pointer tw-items-center tw-border-0 tw-bg-transparent tw-p-1 tw-text-gray-600"
          onClick={() => removeOption(opt)}
          aria-label="Eliminar opción"
        >
          <IconMC name="trash-2-outline" size="base" />
        </button>
      </div>
    )) : (
      <div className="col-md-12 mt-20">
        <div className="figma-field">
          <label>Fuente de datos para opciones</label>
          <Select
            options={variablesOptions}
            placeholder="Selecciona la variable"
            className="select-tag"
            classNamePrefix="select-tag"
            styles={selectStyles}
            onChange={handleVariablesSelect}
            value={[variablesOptions.find((el) => el.value === chatbotOption?.form_options?.data_source)]}
            name="data_source"
            components={{
              IndicatorSeparator: () => null
            }}
          />
        </div>
        <div className="figma-field">
          <label>Valor para cada opción</label>
          <Select
            options={subVariablesOptions}
            placeholder="Selecciona el valor"
            noOptionsMessage={() => "La fuente de datos no tiene variables"}
            className="select-tag"
            classNamePrefix="select-tag"
            styles={selectStyles}
            onChange={handleVariablesSelect}
            value={[subVariablesOptions.find((el) => el.value === chatbotOption?.form_options?.value_source)]}
            name="value_source"
            components={{
              IndicatorSeparator: () => null
            }}
          />
        </div>
        <div className="figma-field">
          <label>Título para cada opción</label>
          <Select
            options={subVariablesOptions}
            placeholder="Selecciona el título"
            noOptionsMessage={() => "La fuente de datos no tiene variables"}
            className="select-tag"
            classNamePrefix="select-tag"
            styles={selectStyles}
            onChange={handleVariablesSelect}
            value={[subVariablesOptions.find((el) => el.value === chatbotOption?.form_options?.title_source)]}
            name="title_source"
            components={{
              IndicatorSeparator: () => null
            }}
          />
        </div>
      </div>
    )}

    {!chatbotOption.use_api && (
      <AddOptionButton
        chatbotOption={chatbotOption}
        optionsList={enabledOptionsList}
        addNewOption={addNewOption}
      />
    )}
  </>
  );
};

export default OptionsSublist;
